import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#2362AD",
  stroke: "#fff",
  "stroke-width": "2",
  d: "m18.153 40.617-.057.042c-.427.317-.94.38-1.352.321s-.885-.261-1.205-.682l-.003-.004L4.209 25.59l-.001-.001C2.165 22.946 1 19.759 1 16.382 1 7.854 8.239 1 17 1s16 6.854 16 15.382c0 3.376-1.165 6.564-3.208 9.207zm0 0 .051-.05.167-.167.048-.047.04-.052 11.332-14.71z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  stroke: "#fff",
  "stroke-width": ".348",
  d: "M23.21 13.607c-.488 0-.884-.382-.884-.854v-1.708c0-.472.396-.854.884-.854v-.855c0-.236.198-.427.443-.427.244 0 .442.191.442.427v.854c.489 0 .885.383.885.855v1.708c0 .472-.396.854-.885.854v4.806c0 .884-.742 1.601-1.658 1.601-.917 0-1.66-.717-1.66-1.601v-1.388c0-.472-.395-.855-.884-.855h-1.105v5.553h.442c.244 0 .442.19.442.427a.435.435 0 0 1-.442.427h-8.846a.435.435 0 0 1-.443-.427c0-.236.198-.427.443-.427h.442v-7.688c0-1.887 1.584-3.417 3.538-3.417h.885c1.954 0 3.539 1.53 3.539 3.416v1.282h1.105c.978 0 1.77.765 1.77 1.709v1.388c0 .413.346.747.774.747a.76.76 0 0 0 .773-.747zm-11.5 2.563v5.553h6.193V16.17zm6.193-.854v-1.282c0-1.415-1.188-2.562-2.654-2.562h-.885c-1.466 0-2.653 1.147-2.653 2.562v1.282zm5.307-4.271v1.708h.885v-1.708zm-9.067 8.329c-.343 0-.556-.362-.38-.647l.665-1.068a.45.45 0 0 1 .606-.147.42.42 0 0 1 .152.587l-.261.42h.545c.344 0 .557.363.38.647l-.664 1.068a.45.45 0 0 1-.607.147.42.42 0 0 1-.151-.586l.261-.421z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }